import React from "react";
import {FormSections} from "../../entities/formTemplateDataType";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {MultiSelect} from "primereact/multiselect";
import {Checkbox} from "primereact/checkbox";
import {InputTextarea} from "primereact/inputtextarea";
import Utils from "../../utilities/Utils";
import {getElementByFieldName, getSectionFilterValueMap} from "../../utilities/ElementUtils";
import {InputText} from "primereact/inputtext";
import {FR_SUFFIX, SummaryStyleList} from "../../entities/Constants";
import {DialogBase} from "./DialogBase";
import { Editor } from "primereact/editor";
import { Panel } from "primereact/panel";

interface Props {
   // programContainer: ProgramContainer
    formSection: FormSections;
    isEng: boolean;
    dialogVisible:boolean;
    callback;
}

interface State {
    pickedFieldOptions;
}

export class DialogForSectionPropertyComponent extends DialogBase<Props,State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
        };
    }

    componentDidMount(): void {
        if(this.props.formSection.FilterField!=null){
            this.onChangeHanlder(this.props.formSection.FilterField)
        }
    }

    onChangeHanlder = (newValue) => {
   
        let totalOption = [];
        const programContainer = this.props.formSection.parent;
        const formListPrior = programContainer.ListOfFormSections.filter(p => p.Sequence < this.props.formSection.Sequence);
        formListPrior.forEach(formSection => formSection.ListOfFormSubSections.forEach((subSection) => {
            let pickedField = subSection.ListOfFormSectionElements.filter(ele => ele.LoadBindName == newValue);

            if(pickedField.length>0){
                let options = pickedField[0].ListOfLOVValues?.map(p => ({
                    code: p.code,
                    description: this.props.isEng? p.description:p.FRADescription
                  }));
                totalOption.push(...options);
            }

        }));

        this.setState({ pickedFieldOptions: totalOption });
      //  this.props.callback();
    }

    generateFilter = () => {
        let html = [];
        let elementListWithOptions = [];
        const programContainer = this.props.formSection.parent;
        //get the section list prior to this one
        let formList =programContainer.ListOfFormSections.filter(p=>p.Sequence<this.props.formSection.Sequence && !p.isTechicalErrorPage && !p.NotStep)

        formList.forEach(formSection=> {
            formSection.ListOfFormSubSections.forEach((subSection) => {
                let list = subSection.ListOfFormSectionElements.filter(
                    (q) =>
                        (q.Datatype === "RadioButton" ||
                            q.Datatype === "CheckGroup" ||
                            q.Datatype === "RadioButtonWithRichText" ||
                            q.Datatype === "Dropdown")
                ).map((q) => {
                    return {
                        code: q.LoadBindName?.replace(/\s/g, ""),
                        description: this.props.isEng ? q.ENUTitle : q.FRATitle
                    };
                });
                 elementListWithOptions.push(...list);
            });
        });

        const filterValueMap = getSectionFilterValueMap(this.props.formSection);
        const originalFilterValueMap = { ...filterValueMap };
        const legacyFilterField = Array.isArray(this.props.formSection.FilterField) ? [...this.props.formSection.FilterField] : [];

        if (!this.props.formSection.FilterValueFRA || Array.isArray(this.props.formSection.FilterValueFRA)) {
            this.props.formSection.FilterValueFRA = {};
        }

        const allowedFields = new Set(elementListWithOptions.map(opt => opt.code));
        const normalizedFilterField = Array.isArray(this.props.formSection.FilterField) ? this.props.formSection.FilterField : [];
        let filterPruned = false;

        const newFilterFieldList: string[] = [];

        for (let i = 0; i < elementListWithOptions.length; i++) {
            let option = elementListWithOptions[i];
            //from code to find element
            const field = getElementByFieldName(option.code, this.props.formSection);
            const optionList = field?.ListOfLOVValues;

            if(!Array.isArray(this.props.formSection.FilterField)){
                this.props.formSection.FilterField=[];
            }
           
            if (Array.from(this.props.formSection.FilterField).indexOf(option["code"]) == -1) {
                this.props.formSection.FilterField.push(option["code"])
            }
            newFilterFieldList.push(option["code"]);

            // prune filter values that no longer exist on the source field
            let currentValues = Array.isArray(filterValueMap[option.code]) ? filterValueMap[option.code] : undefined;
            if (!currentValues && legacyFilterField[i]) {
                const legacyKey = legacyFilterField[i];
                if (Array.isArray(originalFilterValueMap[legacyKey])) {
                    currentValues = originalFilterValueMap[legacyKey];
                    filterValueMap[option.code] = currentValues;
                }
            }
            const currentArray = Array.isArray(currentValues) ? currentValues : [];
            const validCodes = (optionList || []).map(v => v.code);
            // try to realign selections if option codes changed but the position/order stayed the same
            const remappedValues = currentArray.map((val, idx) => {
                if (validCodes.includes(val)) return val;
                const positionalCode = optionList?.[idx]?.code;
                return positionalCode ?? null;
            }).filter(v => v != null) as string[];
            const sanitizedValues = remappedValues.filter(v => validCodes.includes(v));
            if (!optionList || !optionList.length) {
                delete filterValueMap[option.code];
                filterPruned = true;
                continue;
            }
            if (sanitizedValues.length !== currentArray.length) {
                filterValueMap[option.code] = sanitizedValues;
                filterPruned = true;
            }

            html.push(
                <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Field</div>
                        <div style={{ width: '60%' }}>{option["description"]}</div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Value</div>
                        <div style={{ width: '60%', }}>
                            <div>
                                {/* @ts-ignore */}
                                <MultiSelect style={{ width: '100%' }}
                                    className="ontario-dropdown-small"
                                    options={optionList}
                                    value={filterValueMap[option.code] || []}
                                    optionLabel={this.props.isEng ? "description" : "FRADescription"}
                                    optionValue="code"
                                    placeholder="Filtering value"
                                    onChange={(e) => {
                                        //console.log(e.value);
                                        filterValueMap[option.code] = e.value || [];
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        this.props.formSection.FilterField = newFilterFieldList;

        // prune any leftover filter values that no longer have a matching field
        Object.keys(filterValueMap || {}).forEach(key => {
            if (!allowedFields.has(key)) {
                delete filterValueMap[key];
                filterPruned = true;
            }
        });

        // Defer callback to avoid state update during render
        if (filterPruned) {
            setTimeout(() => this.props.callback(), 0);
        }

        return html;
    }
    generateContentString = () => {
      
        let htmlString = [];
        htmlString.push(this.generateFilter());

        htmlString.push(
            <div style={{ width: "100%", paddingTop: "5px" }}>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.PreScript + this.props.formSection.Id}>Pre Script</label>
                    </div>
                    <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                        value={this.props.formSection.PreScript} id={"tbl_" + this.props.formSection.PreScript + this.props.formSection.Id}
                        onChange={(e) => { this.props.formSection.PreScript = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.PostScript + this.props.formSection.Id}>Post Script</label>
                    </div>
                    <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                        value={this.props.formSection.PostScript} id={"tbl_" + this.props.formSection.PostScript + this.props.formSection.Id}
                        onChange={(e) => { this.props.formSection.PostScript = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.StepperScript + this.props.formSection.Id}>Stepper Script</label>
                    </div>
                    <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                        value={this.props.formSection.StepperScript} id={"tbl_" + this.props.formSection.StepperScript + this.props.formSection.Id}
                        onChange={(e) => { this.props.formSection.StepperScript = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.ContinueScript + this.props.formSection.Id}>Continue Script</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input"
                            value={this.props.formSection.ContinueScript}
                            id={"tbl_" + this.props.formSection.ContinueScript + this.props.formSection.Id}
                            onChange={(e) => { this.props.formSection.ContinueScript = e.target.value; this.props.callback() }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.IsFrontPage}>Is Front Page</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.formSection.IsFrontPage}
                            onChange={(e) => { this.props.formSection.IsFrontPage = e.checked; this.props.callback() }}
                            checked={this.props.formSection.IsFrontPage} />
                    </div>
                </div>

                 <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.NoBackButton}>No Back Button</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.formSection.NoBackButton}
                            onChange={(e) => { this.props.formSection.NoBackButton = e.checked; this.props.callback() }}
                            checked={this.props.formSection.NoBackButton} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.NoDefaultContinue}>No Default Continue</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.formSection.NoDefaultContinue}
                            onChange={(e) => { this.props.formSection.NoDefaultContinue = e.checked; this.props.callback() }}
                            checked={this.props.formSection.NoDefaultContinue} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.IsTerminationPage}>Is Termination Page</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.formSection.IsTerminationPage}
                            onChange={(e) => { this.props.formSection.IsTerminationPage = e.checked; this.props.callback() }}
                            checked={this.props.formSection.IsTerminationPage} />
                    </div>
                </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.IsTerminationPage}>Not Counted in Steps</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.formSection.NotCountedInSteps}
                            onChange={(e) => { this.props.formSection.NotCountedInSteps = e.checked; this.props.callback() }}
                            checked={this.props.formSection.NotCountedInSteps} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.NextButtonLabel}>Next button label</label>
                    </div>

                    <div style={{ width: '60%' }}>   
                        <InputText className="ontario-input"
                        value={this.props.isEng?this.props.formSection.NextButtonLabel:this.props.formSection.NextButtonLabelFRA} 
                        id={"tbl_" + this.props.formSection.NextButtonLabel + this.props.formSection.Id}
                        onChange={(e) => {
                            if (this.props.isEng){
                                if(Utils.willDefaultFR(this.props.formSection.NextButtonLabel ,this.props.formSection.NextButtonLabelFRA)){
                                    this.props.formSection.NextButtonLabelFRA= Utils.isNullOrEmpty(e.target.value)? '':e.target.value+ FR_SUFFIX;
                                }
                                this.props.formSection.NextButtonLabel = e.target.value;
                            }else{
                                this.props.formSection.NextButtonLabelFRA = e.target.value;
                            }
                            this.props.callback();
                        }} />
                    </div>

                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.duplicateGroupID}>Group ID for Duplicate</label>
                    </div>
                    <div style={{ width: '60%' }}>   
                        <InputText className="ontario-input"
                            id={"tbl_" + this.props.formSection.duplicateGroupID + this.props.formSection.Id}
                            value={this.props.formSection.duplicateGroupID} onChange={(e) => {
                                this.props.formSection.duplicateGroupID = e.target.value;
                                this.props.formSection.duplicateGroupIndex = this.props.formSection.duplicateGroupID&&this.props.formSection.duplicateGroupID.trim().length>0?0:null;
                                this.props.callback();
                            }} />
                    </div>

                </div>


                <div style={{ display: "flex", marginTop: '10px', width: '100%' }}>
                    <div style={{width: '25%'}}>
                        <label style={{ fontWeight: 'bold' }}>Back Button Configs</label>
                    </div>
                    <div style={{width: '75%', display: 'flex', gap: '10px'}}>
                        <div style={{width: '50%'}}>
                            <label style={{ fontWeight: 'bold' }}>Guest</label>
                        </div>
                        <div style={{width: '50%'}}>
                            <label style={{ fontWeight: 'bold' }}>CXP User</label>
                        </div>
                    </div>
                </div>

                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label id={"tbl_backButtonSectionLabel"}>Label</label>
                    </div>

                    <div style={{width: '75%', display: 'flex', gap: '10px'}}>
                        <div style={{width: '50%'}}>
                            <InputText
                                className="ontario-input"
                                tooltip={'This is the label for public or guest user flow'}
                                tooltipOptions={{position: 'top'}}
                                value={this.props.isEng
                                    ? this.props.formSection.BackButtonLabel
                                    : this.props.formSection.BackButtonLabelFRA}
                                id={"tbl_back_guest_label" + this.props.formSection.Id}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.formSection.BackButtonLabel = e.target.value;
                                    } else {
                                        this.props.formSection.BackButtonLabelFRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}/>
                        </div>
                        <div style={{width: '50%'}}>
                            <InputText
                                className="ontario-input"
                                tooltip={'This is the label for CXP or logged-in user flow'}
                                tooltipOptions={{position: 'top'}}
                                value={this.props.isEng
                                    ? this.props.formSection.BackButtonSignedInLabel
                                    : this.props.formSection.BackButtonSignedInLabelFRA}
                                id={"tbl_back_signin_label" + this.props.formSection.Id}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.formSection.BackButtonSignedInLabel = e.target.value;
                                    } else {
                                        this.props.formSection.BackButtonSignedInLabelFRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}/>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: '10px', display: 'flex'}}>
                    <div style={{width: '25%', display: 'flex', alignItems: 'center', gap: '5px'}}>
                        <label htmlFor={"tbl_" + this.props.formSection.BackButtonURL}>URL</label>
                    </div>

                    <div style={{width: '75%', display: 'flex', gap: '10px'}}>
                        <div style={{width: '50%'}}>
                            <InputText
                                className="ontario-input"
                                tooltip={'This is the url for public or guest user flow'}
                                tooltipOptions={{position: 'top'}}
                                value={this.props.isEng ? this.props.formSection.BackButtonURL : this.props.formSection.BackButtonURLFRA}
                                id={"tbl_back_guest_url"  + this.props.formSection.Id}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.formSection.BackButtonURL = e.target.value;
                                    } else {
                                        this.props.formSection.BackButtonURLFRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}/>
                        </div>
                        <div style={{width: '50%'}}>
                            <InputText
                                className="ontario-input"
                                tooltip={'This is the url for CXP or logged-in user flow'}
                                tooltipOptions={{position: 'top'}}
                                value={this.props.isEng ? this.props.formSection.BackButtonSignInURL
                                    : this.props.formSection.BackButtonSignInURLFRA}
                                id={"tbl_back_signin_url" + this.props.formSection.Id}
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        this.props.formSection.BackButtonSignInURL = e.target.value;
                                    } else {
                                        this.props.formSection.BackButtonSignInURLFRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}/>
                        </div>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`tbl_back_button_stepper_script_${this.props.formSection.Id}`}>Back button Stepper Script</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea
                            id={`tbl_back_button_stepper_script_${this.props.formSection.Id}`}
                            className="ontario-input"
                            value={this.props.formSection.BackButtonStepperScript}
                            onChange={(e) => {
                                this.props.formSection.BackButtonStepperScript = e.target.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ marginTop: '10px', display: 'flex' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`tbl_back_popup_toggle_${this.props.formSection.Id}`}>Back button popup</label>
                    </div>
                    <div style={{ width: '75%', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Checkbox
                            inputId={`tbl_back_popup_toggle_${this.props.formSection.Id}`}
                            checked={!!this.props.formSection.BackButtonShowPopup}
                            onChange={(e) => {
                                this.props.formSection.BackButtonShowPopup = e.checked;
                                this.props.callback();
                            }}
                        />
                        <label htmlFor={`tbl_back_popup_toggle_${this.props.formSection.Id}`}>
                            Show popup before going back
                        </label>
                    </div>
                </div>

                {this.props.formSection.BackButtonShowPopup && (
                    <>
                        <div style={{ marginTop: '10px', display: 'flex' }}>
                            <div style={{ width: '25%' }}>
                                <label htmlFor={`tbl_back_popup_title_${this.props.formSection.Id}`}>Popup title</label>
                            </div>
                            <div style={{ width: '75%' }}>
                                <InputText
                                    className="ontario-input"
                                    id={`tbl_back_popup_title_${this.props.formSection.Id}`}
                                    value={this.props.isEng ? this.props.formSection.BackButtonPopupTitle : this.props.formSection.BackButtonPopupTitleFRA}
                                    onChange={(e) => {
                                        if (this.props.isEng) {
                                            this.props.formSection.BackButtonPopupTitle = e.target.value;
                                        } else {
                                            this.props.formSection.BackButtonPopupTitleFRA = e.target.value;
                                        }
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: '10px', display: 'flex' }}>
                            <div style={{ width: '25%' }}>
                                <label htmlFor={`tbl_back_popup_message_${this.props.formSection.Id}`}>Popup message</label>
                            </div>
                            <div style={{ width: '75%' }}>
                                <InputTextarea
                                    className="ontario-input"
                                    id={`tbl_back_popup_message_${this.props.formSection.Id}`}
                                    value={this.props.isEng ? this.props.formSection.BackButtonPopupMessage : this.props.formSection.BackButtonPopupMessageFRA}
                                    onChange={(e) => {
                                        if (this.props.isEng) {
                                            this.props.formSection.BackButtonPopupMessage = e.target.value;
                                        } else {
                                            this.props.formSection.BackButtonPopupMessageFRA = e.target.value;
                                        }
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: '10px', display: 'flex' }}>
                            <div style={{ width: '25%' }}>
                                <label htmlFor={`tbl_back_popup_buttons_${this.props.formSection.Id}`}>Popup buttons</label>
                            </div>
                            <div style={{ width: '75%', display: 'flex', gap: '10px' }}>
                                <div style={{ width: '50%' }}>
                                    <InputText
                                        className="ontario-input"
                                        id={`tbl_back_popup_stay_${this.props.formSection.Id}`}
                                        placeholder="Stay label"
                                    value={this.props.isEng ? this.props.formSection.BackButtonPopupStayLabel : this.props.formSection.BackButtonPopupStayLabelFRA}
                                        onChange={(e) => {
                                            if (this.props.isEng) {
                                                this.props.formSection.BackButtonPopupStayLabel = e.target.value;
                                            } else {
                                                this.props.formSection.BackButtonPopupStayLabelFRA = e.target.value;
                                            }
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                                <div style={{ width: '50%' }}>
                                    <InputText
                                        className="ontario-input"
                                        id={`tbl_back_popup_leave_${this.props.formSection.Id}`}
                                        placeholder="Go back label"
                                        value={this.props.isEng ? this.props.formSection.BackButtonPopupLeaveLabel : this.props.formSection.BackButtonPopupLeaveLabelFRA}
                                        onChange={(e) => {
                                            if (this.props.isEng) {
                                                this.props.formSection.BackButtonPopupLeaveLabel = e.target.value;
                                            } else {
                                                this.props.formSection.BackButtonPopupLeaveLabelFRA = e.target.value;
                                            }
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.GetToken}>Get Token</label>
                    </div>

                    <div style={{ width: '60%' }}>
                    <Checkbox checked={this.props.formSection.GetToken == 'Y'} value={this.props.formSection.GetToken}
                                className='p-checkbox' title="For Siebel"
                                onChange={(e) => {
                                    this.props.formSection.GetToken = e.checked ? 'Y' : 'N';
                                    this.props.callback();
                                }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label>Hidden</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={!this.props.formSection.Visible}
                            onChange={(e) => { 
                                this.props.formSection.Visible = !e.checked; 
                                this.props.callback();
                            }}
                            checked={!this.props.formSection.Visible} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label>Has Login Banner</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.formSection.LoginBanner}
                            onChange={(e) => { 
                                this.props.formSection.LoginBanner = e.checked; 
                                this.props.callback();
                            }}
                            checked={this.props.formSection.LoginBanner} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label>Login Banner Wording</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea
                            className="ontario-input"
                            value={this.props.isEng ? this.props.formSection.LoginBannerWording : this.props.formSection.LoginBannerWordingFRA}
                            id={"tbl_login_banner_wording_" + this.props.formSection.Id}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    if (Utils.willDefaultFR(this.props.formSection.LoginBannerWording, this.props.formSection.LoginBannerWordingFRA)) {
                                        this.props.formSection.LoginBannerWordingFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                    }
                                    this.props.formSection.LoginBannerWording = e.target.value;
                                } else {
                                    this.props.formSection.LoginBannerWordingFRA = e.target.value;
                                }
                                this.props.callback();
                            }}
                            placeholder="Optional custom text after the ServiceOntario account link"
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label>Has Feedback Banner</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.formSection.FeedbackBanner}
                            onChange={(e) => { 
                                this.props.formSection.FeedbackBanner = e.checked; 
                                this.props.callback();
                            }}
                            checked={this.props.formSection.FeedbackBanner} />
                    </div>
                </div>

                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label>Url Path Name</label>
                    </div>
                    <div style={{width: '60%'}}>
                        <InputText
                            placeholder="Url Path Name for the page"
                            title="Url Page Name"
                            className="ontario-input"
                            style={{width: '100%',}}
                            value={this.props.formSection.pageName || ''}
                            onChange={(e) => {
                                this.props.formSection.pageName = e.target.value;
                                this.props.callback();
                            }}/>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.BackButtonURL}>Background</label>
                    </div>

                    <div style={{ width: '60%' }}>   
                        <InputTextarea className="ontario-input"
                        value={this.props.isEng?this.props.formSection.Background:this.props.formSection.BackgroundFRA} 
                        id={"tbl_" + this.props.formSection.Background + this.props.formSection.Id}
                        onChange={(e) => {
                            if (this.props.isEng){
                                if(Utils.willDefaultFR(this.props.formSection.Background ,this.props.formSection.BackgroundFRA)){
                                    this.props.formSection.BackButtonURLFRA= Utils.isNullOrEmpty(e.target.value)? '':e.target.value+ FR_SUFFIX;
                                }
                                this.props.formSection.Background = e.target.value;
                            }else{
                                this.props.formSection.BackgroundFRA = e.target.value;
                            }
                            this.props.callback();
                        }} />
                    </div>
                </div>
                
                <div style={{ display: "flex", marginTop: '10px', width: '100%' }}>
                    <div style={{width: '25%'}}>
                        <label style={{ fontWeight: 'bold' }}>Customized Summary Configs</label>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"review-style-" + this.props.formSection.Id}>Customized Review Style</label>
                    </div>

                    <div style={{ width: '60%' }}>
                        <Dropdown
                            id={"review-style-" + this.props.formSection.Id}
                            options={SummaryStyleList}
                            optionLabel='label' 
                            optionValue='val'
                            value={this.props.formSection.CustomizedSummaryProps?.customizedSummaryStyle || this.props.formSection.CustomizedStyle}
                            onChange={(e) => {
                                if (this.props.formSection.CustomizedSummaryProps) {
                                    this.props.formSection.CustomizedSummaryProps.customizedSummaryStyle = e.value;
                                } else {
                                    this.props.formSection.CustomizedSummaryProps = {customizedSummaryStyle: e.target.value};
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                {this.props.formSection.CustomizedSummaryProps?.customizedSummaryStyle == "Button" && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"incl-can-btn-" + this.props.formSection.Id}>Including Cancel button</label>
                        </div>

                        <div style={{ width: '20%' }}>
                            <Checkbox 
                                id={"incl-can-btn-" + this.props.formSection.Id}
                                checked={this.props.formSection.CustomizedSummaryProps?.includingCancelButton == 'Y' || this.props.formSection.IncludingCancelButton == 'Y' } 
                                value={this.props.formSection.CustomizedSummaryProps?.includingCancelButton || this.props.formSection.IncludingCancelButton}
                                className='p-checkbox' title="Including Cancel button"
                                onChange={(e) => {
                                    if (this.props.formSection.CustomizedSummaryProps) {
                                        this.props.formSection.CustomizedSummaryProps.includingCancelButton = e.checked ? 'Y' : 'N';
                                    } else {
                                        this.props.formSection.CustomizedSummaryProps = {includingCancelButton: e.checked ? 'Y' : 'N'};
                                    }
                                    this.props.callback();
                                }} 
                            />
                        </div>
                    </div>
                )}
                {this.props.formSection.CustomizedSummaryProps?.customizedSummaryStyle == "Button" && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"cancel_btn_script-" + this.props.formSection.Id}>Cancel button Script</label>
                        </div>

                        <div style={{ width: '60%' }}>
                            <InputTextarea 
                                id={"cancel_btn_script_" + this.props.formSection.Id}
                                className="ontario-input"
                                value={this.props.formSection.CustomizedSummaryProps?.cancelButtonScript} 
                                onChange={(e) => { 
                                    if (this.props.formSection.CustomizedSummaryProps) {
                                        this.props.formSection.CustomizedSummaryProps.cancelButtonScript = e.target.value;
                                    } else {
                                        this.props.formSection.CustomizedSummaryProps = {cancelButtonScript: e.target.value};
                                    }
                                    this.props.callback();
                                }} 
                            />
                        </div>
                    </div>
                )}

                {this.props.formSection.CustomizedSummaryProps?.customizedSummaryStyle == "Table" && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"change_link_subsection-" + this.props.formSection.Id}>Change link in sub-section level</label>
                        </div>

                        <div style={{ width: '20%' }}>
                            <Checkbox 
                                id={"change_link_subsection_" + this.props.formSection.Id}
                                checked={this.props.formSection.CustomizedSummaryProps?.changeLinkInSubsectionLevel} 
                                value={this.props.formSection.CustomizedSummaryProps?.changeLinkInSubsectionLevel}
                                className='p-checkbox' title="Including Cancel button"
                                onChange={(e) => {
                                    if (this.props.formSection.CustomizedSummaryProps) {
                                        this.props.formSection.CustomizedSummaryProps.changeLinkInSubsectionLevel = e.checked;
                                    } else {
                                        this.props.formSection.CustomizedSummaryProps = {changeLinkInSubsectionLevel: e.checked};
                                    }
                                    this.props.callback();
                                }} 
                            />
                        </div>
                    </div>
                )}
                {this.props.formSection.CustomizedSummaryProps?.customizedSummaryStyle == "Table" && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"link-script-" + this.props.formSection.Id}>Change link script</label>
                        </div>

                        <div style={{ width: '60%' }}>
                            <InputTextarea 
                                id={"link-script-" + this.props.formSection.Id}
                                className="ontario-input"
                                value={this.props.formSection.CustomizedSummaryProps?.changeLinkScript} 
                                onChange={(e) => { 
                                    if (this.props.formSection.CustomizedSummaryProps) {
                                        this.props.formSection.CustomizedSummaryProps.changeLinkScript = e.target.value;
                                    } else {
                                        this.props.formSection.CustomizedSummaryProps = {changeLinkScript: e.target.value};
                                    }
                                    this.props.callback();
                                }} 
                            />
                        </div>
                    </div>
                )}
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"hide_all_change_links_" + this.props.formSection.Id}>Hide all Change links</label>
                    </div>

                    <div style={{ width: '20%' }}>
                        <Checkbox
                            id={"hide_all_change_links_" + this.props.formSection.Id}
                            checked={this.props.formSection.CustomizedSummaryProps?.hideAllChangeLinks}
                            value={this.props.formSection.CustomizedSummaryProps?.hideAllChangeLinks}
                            className='p-checkbox' title="Hide all Change links"
                            onChange={(e) => {
                                if (this.props.formSection.CustomizedSummaryProps) {
                                    this.props.formSection.CustomizedSummaryProps.hideAllChangeLinks = e.checked;
                                } else {
                                    this.props.formSection.CustomizedSummaryProps = {hideAllChangeLinks: e.checked};
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{display: "flex", marginTop: '10px'}}>
                    <div style={{width: '25%'}}>
                        <label>API</label>
                    </div>
                    <div style={{width: '60%'}}>
                        <InputText
                            placeholder="get initial data from API"
                            title="Get initial data from API"
                            className="ontario-input"
                            style={{width: '100%',}}
                            value={this.props.formSection.GetAPI || ''}
                            onChange={(e) => {
                                this.props.formSection.GetAPI = e.target.value;
                                this.props.callback();
                            }}/>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"skip_page_view_tracking_" + this.props.formSection.Id}>Skip if Previously Agreed</label>
                    </div>
                    <div style={{ width: '20%' }}>
                        <Checkbox 
                            id={"skip_page_view_tracking_" + this.props.formSection.Id}
                            checked={this.props.formSection.SkipPageViewTracking || false} 
                            value={this.props.formSection.SkipPageViewTracking}
                            className='p-checkbox' 
                            title="Skip this section (navigation & tracking) only if user has agreedToTermsOfUseOn. Otherwise, section is shown and tracked normally."
                            onChange={(e) => {
                                this.props.formSection.SkipPageViewTracking = e.checked;
                                this.props.callback();
                            }} 
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"keep_continue_button_left_" + this.props.formSection.Id}>Keep Continue button left</label>
                        </div>

                        <div style={{ width: '20%' }}>
                            <Checkbox 
                                id={"keep_continue_button_left_" + this.props.formSection.Id}
                            checked={this.props.formSection.KeepContinueButtonLeft} 
                            value={this.props.formSection.KeepContinueButtonLeft}
                            className='p-checkbox' title="Keep Continue button left"
                            onChange={(e) => {
                                this.props.formSection.KeepContinueButtonLeft = e.checked;
                                this.props.callback();
                            }} 
                        />
                    </div>
                </div>

                 <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"display_mask_icon_left_" + this.props.formSection.Id}>Display Mask Icon Left</label>
                        </div>
                        <div style={{ width: '20%' }}>
                            <Checkbox 
                                id={"display_mask_icon_left_" + this.props.formSection.Id}
                            checked={this.props.formSection.DisplayMaskIconLeft?? false}
                            value={this.props.formSection.DisplayMaskIconLeft?? false}
                            className='p-checkbox' title="Keep Mask Icon Left"
                            onChange={(e) => {
                                 const element = this.props.formSection;
                                if (element) { 
                                    element.DisplayMaskIconLeft = e.checked;
                                this.props.callback();
                                }
                            }} 
                        />
                    </div>
                </div>            


                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.formSection.HaveTopButton}>Show Top button</label>
                    </div>

                    <div style={{ width: '20%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            id={"have_top_button_" + this.props.formSection.Id}
                            checked={!!this.props.formSection.HaveTopButton}
                            value={this.props.formSection.HaveTopButton}
                            className='p-checkbox' title="Show Top button on page"
                            onChange={(e) => {
                                this.props.formSection.HaveTopButton = e.checked;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
            </div>
        );

        return htmlString;
    };
  
    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(<>
        {/* @ts-ignore */}
        <Dialog header={this.props.isEng ? "Section properties for " + this.props.formSection.ENUTitle : "Section properties for" + this.props.formSection.FRATitle} footer={this.renderFooter()}
            visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
            {this.generateContentString()}
        </Dialog></>);
        return html;
    }

  
    render() {
    
        return (
            <div>
                {this.generateHtmlString()}
            </div>
        );
    }
}
